import styled from "styled-components";
import { StyledWizardAnimationWrapper } from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/styles";

export const StyledWizardLoadingWrapper = styled(StyledWizardAnimationWrapper)`
    height: 100%;
    
    & > div {
        height: 100%;
    }
`